export default __webpack_public_path__ + "static/media/microscope.ef59e8a3.png";